import { useQuery } from "@tanstack/react-query";

// Hooks
import { useFetchUser } from "./useFetchUser";

// Interfaces
import { Stat } from "../interfaces/Stat";

// Firebase
import { genDoc } from "../utils/firebase";
import { firestore } from "../firebase/firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
export const useFetchStats = () => {
    // Hooks
    const { currentParticipant } = useFetchUser();

    const { data: stats = [] } = useQuery(
        ["stats", currentParticipant?.id],
        async () => {
            if (!currentParticipant?.id) return [];

            let statsQuery = query(collection(firestore, "Stats"), where("participantId", "==", currentParticipant.id));

            if (currentParticipant.resetDate) {
                statsQuery = query(
                    collection(firestore, "Stats"),
                    where("participantId", "==", currentParticipant.id),
                    where("createdAt", ">=", currentParticipant.resetDate)
                );
            }

            const payload = await getDocs(statsQuery);
            return payload.docs.map(genDoc<Stat>());
        },
        {
            enabled: !!currentParticipant?.id,
        }
    );

    return { stats };
};
